import React, {Component} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router'
import {resetPassword, removeNotification, removeAllNotifications} from '../actions';
import EmailInput from './common/EmailInput';
import logo from '../../resources/images/logo_grey.png'
import Load from './Load'
import {AlertList} from 'react-bs-notifier';

class PasswordReset extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: ''
        }
    }

    handleEmailInput = (e) => {
        this.setState({email: e});
    }

    render() {
        //console.log('pwReset',this.props.routeParams);

        return (
            <div className="password-box">
                <AlertList
                    timeout={4000}
                    alerts={this.props.notifications || []}
                    onDismiss={(alert) => {this.props.dispatch(removeNotification(alert))}}
                />

                <img style={{float: 'right', width: '140px', height: '70px'}} src={logo} alt="logo"/>

                <div className="sign-in">PASSWORD RESET</div>

                <div>
                    <div>Enter your email below and we'll send you instructions on how to reset your password</div>
                    <EmailInput label="Email address" placeholder="" onChange={this.handleEmailInput}/>
                    <button className="submit sign-in-button" onClick={() => this.props.dispatch(resetPassword(this.state.email))}>Submit</button>
                    <button className="link forgot-password" onClick={() => {
                        this.props.dispatch(removeAllNotifications());
                        browserHistory.push('/login');
                    }}>Cancel</button>
                    {(this.props.loading || {}).resetPassword && <Load/>}
                </div>
            </div>
        );
    }
}

export default PasswordReset = connect((state) => {
    return {
        loading: (state.data || {}).loading || {},
        notifications: (state.data || {}).notifications
    }
})(PasswordReset);





// WEBPACK FOOTER //
// ./src/components/PasswordReset.jsx